"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNS = exports.resources = void 0;
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var en_json_1 = __importDefault(require("@translations/en.json"));
var en_json_2 = __importDefault(require("@features/SettingsPage/translations/en.json"));
var en_json_3 = __importDefault(require("@features/StatisticPage/translations/en.json"));
var en_json_4 = __importDefault(require("@features/ItemLogPage/translations/en.json"));
exports.resources = {
    en: {
        common: en_json_1.default,
        settings: en_json_2.default,
        statistics: en_json_3.default,
        itemLog: en_json_4.default,
    },
};
exports.defaultNS = 'common';
i18next_1.default
    .use(react_i18next_1.initReactI18next) // passes i18n down to react-i18next
    .init({
    returnNull: false,
    ns: ['common', 'settings', 'itemLog'],
    resources: exports.resources,
    defaultNS: exports.defaultNS,
    lng: 'en',
    keySeparator: '.',
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
});
exports.default = i18next_1.default;
